import Swiper from 'swiper/swiper-bundle.mjs';
import domContentLoaded from 'utils/domContentLoaded';
import breakpoints from 'utils/breakpoints';

/**
 * Create a Desire Hub editorial Swiper for tablet/desktop.
 *
 * @param {HTMLElement} slider Swiper root element.
 *
 * @return {Swiper} Swiper instance.
 */
function createSwiper(slider) {
  const sliderWrap = slider.parentElement;
  const prevEl = sliderWrap?.querySelector('.swiper-button-prev');
  const nextEl = sliderWrap?.querySelector('.swiper-button-next');

  return new Swiper(slider, {
    slidesPerView: 3,
    slidesPerGroup: 1,
    spaceBetween: 24,
    navigation: {
      nextEl,
      prevEl,
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
      },
    },
  });
}

/**
 * Enable Swiper from md up; destroy it on mobile so slides stack.
 *
 * @return {void}
 */
function initCarousels() {
  document.querySelectorAll('.js-desire-hub-editorial-carousel').forEach((slider) => {
    if (breakpoints.mdMin.matches) {
      if (! slider.swiper) {
        createSwiper(slider);
      }
    } else if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }
  });
}

domContentLoaded(() => {
  initCarousels();
  breakpoints.mdMin.addListener(initCarousels);
});
